import { ToFloat } from './utils';
import { getQuantumAmount } from './money';

export function GetConsumption(aid: Aid.IAid) {
  const count = getQuantumAmount(aid);

  if (ToFloat(aid.consumption) > count) {
    return count;
  }
  return ToFloat(aid.consumption);
}

export function GetAidsApprovedTotal(aids: Aid.IAid[]) {
  return aids.map(aid => getQuantumAmount(aid)).reduce((a, b) => a + b, 0);
}

export function GetAidsEffectiveTotal(aids: Aid.IAid[]) {
  return aids.map(aid => GetConsumption(aid)).reduce((a, b) => a + b, 0);
}

export function GetAidsTotalConsumption(aids: Aid.IAid[]) {
  return aids.map(aid => ToFloat(aid.consumption)).reduce((a, b) => a + b, 0);
}
